<div class="content-container">
  <h2>Calculadora TCO</h2>

  <p>Esta herramienta permite evaluar y comparar los costos de todo el ciclo de vida de
    camiones convencionales y eléctricos (a batería y celda de combustible de hidrógeno). Es una herramienta útil para
    cuantificar los costos totales de propiedad (TCO, por sus siglas en inglés: Total Cost of Ownership) ya que incluye
    los costos de adquisición, operación y de fin de ciclo de vida.</p>

  <div class="flex-container">
    <app-calc-intro-content-box imageUrl="contact-form.png"
                                imageAlt="contact form"
                                title="Completá los datos"
                                description="Datos acerca del camión, la operación y la economía son necesarios para hacer la comparación entre las distintas
  tecnologías. Se recomienda dedicar tiempo a la recopilación de información para que los resultados reflejen la realidad de
  los costos a los que se va a incurrir."></app-calc-intro-content-box>
    <app-calc-intro-content-box imageUrl="statistics-lens.png"
                                imageAlt="magnifying glass"
                                title="Revisá los supuestos"
                                description="Hay parámetros que fueron sugeridos como supuestos para la evaluación de costos con la finalidad de simplificar el proceso.
  Los supuestos se muestran y se pueden cambiar según se entienda conveniente."></app-calc-intro-content-box>
    <app-calc-intro-content-box imageUrl="statistics.png"
                                imageAlt="bar and pie chart"
                                title="Compará los costos"
                                description="Se muestran los resultados de forma comparativa entre las tecnologías escogidas para analizar."></app-calc-intro-content-box>
  </div>

  <a class="calculator-link" mat-button routerLink="/calculadora">Empezar</a>
</div>

<div class="fill-space"></div>

<div class="screen-bottom-positioning">
  <div class="blue-horizontal-line"></div>
  <app-footer></app-footer>
</div>
